// extracted by mini-css-extract-plugin
export default {"wrapper":"h1-z","play":"i1-z"};